export default "__VITE_ASSET__oYcjBtke__"